import { http } from "@/api/config.js";
import qs from "qs";
//cookie参数
let cookieList = document.cookie ? document.cookie.split(";") : [];
let cookies = {};
cookieList.forEach((item) => {
  if (!cookies[item.split("=")[0].trim()])
    cookies[item.split("=")[0].trim()] = item.split("=")[1];
});

//考试信息
export const GetVocabularyExamsApi = (data) => {
  data.userId = cookies["user-idcon"];
  for (let key in data) {
    if (data[key] === "") delete data[key];
  }

  return http({
    url: `/vspt/resume_exam_info/?${qs.stringify(data, {
      arrayFormat: "repeat",
    })}`,
    method: "POST",
  });
};

//开始考试
// userIdCon：用户编号
// examIdCon：考试编号
// startTime：1
export const SetVocabularyExamTimeApi = (data) => {
  data.userId = cookies["user-idcon"];
  data._ = new Date().getTime();
  return http({
    url: `/vspt/begin?${qs.stringify(data, { arrayFormat: "repeat" })}`,
    method: "GET",
  });
};
export const SaveVocabularyStartMsgApi = (data) => {
  data.userId = cookies["user-idcon"];
  return http({
    url: `/vspt/saveQ?${qs.stringify(data, { arrayFormat: "repeat" })}`,
    method: "POST",
  });
};
//进度
export const NextVocabularyApi = (data) => {
  data.userId = cookies["user-idcon"];
  if (data.answer) data.answer = JSON.stringify(data.answer);
  return http({
    url: `/vspt/next`,
    method: "POST",
    data: qs.stringify(data, {
      arrayFormat: "repeat",
    }),
  });
};
// examId:
// userId:
// curStage:部分
// curItemNo:序号
// curItemId:
// curItemIndex:
// curQIndex:
// answer:
// daojishi:
// version:

export const SetResumeApi = (data) => {
  data.userId = cookies["user-idcon"];
  if (data.answer) data.answer = JSON.stringify(data.answer);
  return http({
    url: `/vspt/cache`,
    method: "POST",
    data: qs.stringify(data, {
      arrayFormat: "repeat",
    }),
  });
};
//交卷
export const SubmitExamApi = (data) => {
  data.userId = cookies["user-idcon"];
  if (data.answer) data.answer = JSON.stringify(data.answer);
  return http({
    url: `/vspt/submit`,
    method: "POST",
    data: qs.stringify(data, {
      arrayFormat: "repeat",
    }),
  });
};
